import { isObject, isUndefined } from '@/src/helpers';
import { ErrorResponse, XrplError } from 'xrpl';

/**
 * Subset of XRPLErrorCodes that we handle from the [full list](https://github.com/XRPLF/rippled/blob/develop/include/xrpl/protocol/ErrorCodes.h)
 */
export enum KnownXrplErrorCodes {
  AccountNotFound = 19,
  AccountMalformed = 35,
  InvalidParams = 31,
  ObjectNotFound = 92,
  OracleMalformed = 94,
}

/**
 * Check if XRPL.js ErrorResponse is the provided errorCode
 * @param {ErrorResponse} error
 * @param {KnownXrplErrorCodes} errorCode Error code to check against
 * @returns if ErrorResponse.error_code matches provided errorCode
 */
export const isXRPLErrorCode = (
  error: ErrorResponse,
  errorCode: KnownXrplErrorCodes
) => !isUndefined(error.error_code) && parseInt(error.error_code) === errorCode;

/**
 * Check if error is coming from XRPL.js
 * @param thing Maybe an XRPL.js error object
 */
export const isXRPLErrorResponse = (
  thing: unknown
): thing is { data: ErrorResponse } =>
  thing instanceof XrplError &&
  isObject(thing.data) &&
  thing.data.status === 'error' &&
  thing.data.type === 'response';
